// Vuex
import { mapActions, mapState } from 'vuex'

// Tener DISPONIBLE el "comparacion" state de 

export default {

    name: 'matrixCompatibilityIndex',

    data() {
        return {
            agregarProducto: false,
            title: '',
            message: '',
            initloading: false, 
        }
    },

    computed: {
        ...mapState('matrizCompatibilidadAlmacenamiento', {
            loadingToComparisonIndex: 'loading'
        }),
    },

    methods: {

        ...mapActions('matrizCompatibilidadAlmacenamiento', [            
            'actualizarComparacion',
        ]),
        
        getCompatibilityStatus(comparisonData, product1, product2) {
            if (!comparisonData || !comparisonData.resultados ||
                !product1 || !product1.id || !product2 || !product2.id) {
                return 'revision';
            }

            if (!comparisonData.resultados[product1.id] ||
                !comparisonData.resultados[product1.id][product2.id]) {
                return 'revision';
            }

            const status = comparisonData.resultados[product1.id][product2.id];

            return status === 1 ? 'compatible' :
                status === -1 ? 'incompatible' :
                    'revision';
        },

        verification(comparisonData, product1, product2) {
            if (!comparisonData || !comparisonData.inVerification ||
                !product1 || !product1.id || !product2 || !product2.id) {
                return true;
            }

            return !Object.entries(comparisonData.inVerification).some(([key, values]) => {
                if (Number(key) === product1.id) {
                    return Object.entries(values).some(([key2, value]) => {
                        return Number(key2) === product2.id && value === true;
                    });
                }
                return false;
            });
        },

        async updateDataToComparison() {
            this.agregarProducto = true
            this.title = 'Comparando peligrosidades (SGA) y propiedades fisicoquímicas.';
            this.message = 'Estamos analizando cada producto para contrastar su clasificación según el Sistema Globalmente Armonizado (SGA) con las propiedades fisicoquímicas reportadas. Este proceso puede durar un momento, por favor espera.';
            this.initloading = true;
            await this.actualizarComparacion()
            this.initloading = this.loadingToComparisonIndex;
        }

    }

}